import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges
} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {environment} from "../../../../../environments/environment";

@Component({
  selector: 'app-project-cards',
  templateUrl: './project-cards.component.html',
  styleUrls: ['./project-cards.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectCardsComponent implements OnInit, OnChanges {
  @Input() projectCards: any[] = [];
  @Input() archivedProjectCards: any[] = [];
  @Input() showArchived: boolean = false;
  @Input() projectDefaultCategories: any[] = [];
  @Input() set filterByIndicator(value: any) {
    this.selectedIndicator = value;
  };
  @Input() set sortByFilter(value: any) {
      this.selectedRadioButton = value ? this.radioButtons.find((btn: any) => btn.value === value) : this.radioButtons[1];
  };
  @Input() quickActionData!: any;

  @Output() sortByChange = new EventEmitter<any>();
  @Output() indicatorSortEvent = new EventEmitter<any>();
  @Output() loadQuickActionMenuData = new EventEmitter<any>();
  @Output() emitPauseOrResumeProject = new EventEmitter<any>();
  @Output() emitGoToDashboard = new EventEmitter<any>();
  @Output() emitToggleArchived = new EventEmitter<boolean>();


  displayedCards: any[] = [];
  selectedRadioButton: any;
  selectedIndicator: any;
  selectedProjectCard: any | null = null;
  selectedTriggerEl: any | null;
  cardPositions: any = {
    middleScroll: false,
    shouldOpenLeft: false,
    bottomScroll: false
  }
  archivedMenuStyle: any = null;

  baseUrl!: string;

  radioButtons: any[] = [
    {label: this.translate.instant('team_overview_high'),slug: 'highest', id: 'radio1', value: 'DESC'},
    {label: this.translate.instant('team_overview_low'),slug: 'lowest', id: 'radio2', value: 'ASC'}];

  constructor(
    private translate: TranslateService,
    private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.baseUrl = environment.baseUrl;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['projectCards'] || changes['archivedProjectCards'] || changes['showArchived']) {
      this.displayedCards = this.showArchived
        ? [...this.projectCards, ...this.archivedProjectCards]
        : this.projectCards;
    }
  }

  setFilterByScore() {
    this.sortByChange.emit(this.selectedRadioButton?.value);
  }

  changeIndicator(indicator: any) {
    this.indicatorSortEvent.emit(indicator);
  }

  toggleArchived() {
    this.emitToggleArchived.emit(!this.showArchived);
  }

  openQuickActionsMenu(cardProject: any, triggerEl: HTMLElement) {
    this.selectedProjectCard = cardProject;
    this.archivedMenuStyle = null;
    this.showSidePanel(triggerEl);
    this.loadQuickActionMenuData.emit(cardProject.project.uuid);
  }

  showSidePanel(triggerEl: HTMLElement) {
    this.cardPositions.middleScroll = false;
    this.cardPositions.bottomScroll = false;

    const rect = triggerEl.getBoundingClientRect();
    const panelWidth = 300;
    const padding = 52;
    const spaceRight = window.innerWidth - rect.right;

    this.cardPositions.shouldOpenLeft = spaceRight < (panelWidth + padding);
    this.cdr.detectChanges();
    requestAnimationFrame(() => {
        this.adjustPosition(triggerEl);
    });
  }

  adjustPosition(triggerEl: HTMLElement) {
    const panel = triggerEl.querySelector('.app-quick-actions-menu') as HTMLElement;
    if (!panel) return;

    const cardRect = triggerEl.getBoundingClientRect();
    const menuRect = panel.getBoundingClientRect();

    const menuHeight = menuRect.height;

    const spaceAbove = cardRect.top;
    const spaceBelow = window.innerHeight - cardRect.bottom;

    this.cardPositions.middleScroll = false;
    this.cardPositions.bottomScroll = false;
    this.cardPositions.topScroll = false;

    if (
      spaceAbove >= menuHeight / 2 &&
      spaceBelow >= menuHeight / 2
    ) {
      this.cardPositions.middleScroll = true;
      this.archivedMenuStyle = this.selectedProjectCard?.project.isArchived
        ? {'top.px': (cardRect.height - menuHeight) / 2}
        : null;
    } else if (spaceBelow < menuHeight / 2) {
      this.cardPositions.bottomScroll = true;
      this.archivedMenuStyle = null;
    } else {
      this.cardPositions.topScroll = true;
      this.archivedMenuStyle = null;
    }

    this.cdr.detectChanges();
  }

  pauseOrResumeProject(data: any) {
    this.emitPauseOrResumeProject.emit(data);
  }

  closeQuickActionsMenu() {
    this.selectedProjectCard = null;
    this.archivedMenuStyle = null;
  }

  goToProjectDashboard() {
    this.emitGoToDashboard.emit(this.selectedProjectCard);
  }

}
